module.exports = __webpack_public_path__ + "img/grasse_7.329dc0c1.png";